export default __webpack_public_path__ + "static/media/pwa2500Credits.5cb4266f.png";